export const ISSUE_TYPE_FIELD_ASSOCIATION_QUERY = `query JiraWorkTypeFieldAssociation($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
  jiraBusinessAvailableFields(
    projectKey: $projectKey
    issueOperation: $issueOperation
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    edges {
      node {
        issueType {
          issueTypeId
        }
        fields {
          edges {
            node {
              fieldId
            }
          }
        }
      }
    }
  }
}`;
